<!-- 
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
SPDX-License-Identifier: MIT-0  
-->

<script setup>
import AuthenticateForm from "@/components/AuthenticateForm.vue";
</script>
<template>
  <authenticate-form></authenticate-form>
</template>

<style></style>
